module.exports = __webpack_public_path__ + "static/media/estudio-img.de203fc7.png";